<template>
  <modal :name="name" height="auto" width="560" :scrollable="true" :clickToClose="false">
    <CloseModal :close="close" />
    <div class="modalbox">
      <div class="modalbox-content">
        <h5 class="tinto-modal__title">Vincular EAN — {{ subtitle }}</h5>

        <div class="tinto-section">
          <div class="tinto-section__label">EAN atual</div>
          <div v-if="eanAtual" style="font-size:13px;color:#344054;padding:4px 0">
            {{ eanAtual }}
          </div>
          <div v-else class="tinto-table__muted" style="padding:4px 0">Sem EAN vinculado</div>
        </div>

        <div class="form-group mt-3">
          <label class="tinto-label">Buscar Produto</label>
          <div class="input-group input-group-sm">
            <input class="form-control form-control-sm" v-model="busca" placeholder="Digite nome ou código..." @keyup.enter="buscar" />
            <div class="input-group-append">
              <button class="button" @click="buscar"><fa-icon icon="search" /></button>
            </div>
          </div>
        </div>

        <div v-if="resultados.length > 0" class="tinto-table-wrap" style="max-height:200px;overflow-y:auto;margin-bottom:12px">
          <table class="tinto-table">
            <tbody>
              <tr v-for="p in resultados" :key="p.id" @click="selecionar(p)" style="cursor:pointer" :class="{'table-active': produtoSelecionado && produtoSelecionado.id === p.id}">
                <td style="width:80px">{{ p.id }}</td>
                <td>{{ p.descComp }}</td>
                <td style="width:120px"><span v-if="p.codBarra">{{ p.codBarra }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="produtoSelecionado" class="tinto-section">
          <span class="tinto-section__label">Produto selecionado</span>
          <div style="font-size:13px;color:#344054">{{ produtoSelecionado.descComp }}</div>
          <div style="font-size:11px;color:#667085">ID: {{ produtoSelecionado.id }}</div>
        </div>
      </div>
    </div>
    <div class="tinto-modal__footer">
      <button class="button" @click="close">Cancelar</button>
      <button class="button button-primary" @click="submit" :disabled="!produtoSelecionado || saving">Salvar</button>
    </div>
  </modal>
</template>

<script>
import CloseModal from "../../components/CloseModal";
import { get, put } from '@/helpers/apiRequest';

export default {
  name: "TintometricoVincularEanModal",
  components: { CloseModal },

  props: {
    name:     { type: String, required: true },
    subtitle: { type: String, default: '' },
    eanAtual: { type: String, default: '' },
    endpoint: { type: String, default: '' },
  },

  data() {
    return {
      busca: '',
      resultados: [],
      produtoSelecionado: null,
      saving: false,
    };
  },

  methods: {
    reset() {
      this.busca = '';
      this.resultados = [];
      this.produtoSelecionado = null;
    },

    close() {
      this.reset();
      this.$modal.hide(this.name);
    },

    buscar() {
      if (!this.busca) return;
      const termo = this.busca.trim();
      const isNumeric = /^\d+$/.test(termo);
      const filtro = isNumeric ? `filtros[produto_id]=${termo}` : `filtros[termo]=${encodeURIComponent(termo)}`;
      get(`/admin/produtos?${filtro}&page=1`)
        .then(json => { this.resultados = json.itens || []; });
    },

    selecionar(produto) {
      this.produtoSelecionado = produto;
    },

    submit() {
      if (!this.produtoSelecionado) return;
      this.saving = true;
      put(this.endpoint, { produto_id: this.produtoSelecionado.id })
        .then(() => {
          this.$emit('saved');
          this.close();
        })
        .catch(e => { this.$swal({ title: 'Erro', text: e.message, icon: 'error' }); })
        .finally(() => { this.saving = false; });
    },
  },
};
</script>
